// @owners { team: patients-team }
import { type CoachmarkKey } from '~shared/actions/ui/coachmarks';
import { type ReduxStateShared } from '~shared/store';

export const getCoachmarkViewedStatus = (state: ReduxStateShared, coachmarkKey: CoachmarkKey) =>
  state.persistedUI.coachmarks.seenCoachmarks[coachmarkKey] || false;
